export const introduce = {
  text: `### 指标原理
  + 该指标统计了链上交易的Token数量`,
  height: 1290,
};